module.exports = __webpack_public_path__ + "static/design-a96ca38c9a793caf51b3159279795d6e.png";